import { useNavigate, useParams  } from "react-router";
import {useLocation} from "react-router-dom";
export default function withRouter(Component) {
    return props => (<Component {...props} location={useLocation()} params={useParams()} navigate={useNavigate()} />)
}